/**
 * tw-bundle-builder-b.js
 * Travel Wicks — Bundle Builder B Variant (Wax Melt A/B Test)
 *
 * Owns: UI state for tier detection, progress bar updates, upsell nudge copy,
 *       and Add to Cart activation. Wax melts only.
 *
 * Does NOT own: cart payload construction (tw-bundle-builder.js),
 *               scent selection logic, inventory gating, or cart submission.
 *
 * Contract: populates window.TWBuilder.selectedJourney and dispatches
 *           tw:journey:selected when a tier threshold is reached.
 *           All downstream logic (tw-bundle-builder.js) reads from that
 *           contract unchanged.
 *
 * Tier data is passed in from Liquid via window.TWBuilderB.tiers (see
 * tw-journey-selector-b.liquid schema output). Nothing is hardcoded.
 */

(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Tier data is injected by tw-journey-selector-b.liquid into
  // window.TWBuilderB.tiers as an array sorted by item_count ascending:
  // [
  //   { title: 'Discovery Journey', item_count: 3, variant_id: 123, price: '38.00' },
  //   { title: 'Extended Journey',  item_count: 6, variant_id: 456, price: '72.00' },
  //   { title: "Collector's Journey", item_count: 10, variant_id: 789, price: '98.00' }
  // ]
  // ------------------------------------------------------------------

  function formatMoney(decimalString) {
    var amount = parseFloat(decimalString);
    return '$' + amount.toFixed(2).replace(/\.00$/, '.00');
  }

  function getTiers() {
    return (window.TWBuilderB && window.TWBuilderB.tiers) ? window.TWBuilderB.tiers : [];
  }

  // Returns the tier the customer currently qualifies for based on count.
  // Returns null if count is below the first threshold.
  function getActiveTier(count) {
    var tiers = getTiers();
    var active = null;
    for (var i = 0; i < tiers.length; i++) {
      if (count >= tiers[i].item_count) {
        active = tiers[i];
      }
    }
    return active;
  }

  // Returns the next tier above the current count, or null if at max.
  function getNextTier(count) {
    var tiers = getTiers();
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].item_count > count) {
        return tiers[i];
      }
    }
    return null;
  }

  // Returns the tier at exactly the current count (threshold hit), or null.
  function getExactTier(count) {
    var tiers = getTiers();
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].item_count === count) {
        return tiers[i];
      }
    }
    return null;
  }

  // ------------------------------------------------------------------
  // Nudge copy -- all prices from metaobject data, no hardcoding
  // ------------------------------------------------------------------
  function getNudgeCopy(count) {
    var tiers = getTiers();
    if (!tiers.length) return '';

    var first = tiers[0];
    var second = tiers[1] || null;
    var third = tiers[2] || null;

    // 0 scents
    if (count === 0) {
      return 'Choose ' + first.item_count + ' scents to begin your ' + first.title + ' for ' + formatMoney(first.price) + '. Add more to go further.';
    }

    // Approaching first tier
    if (count < first.item_count) {
      var remaining = first.item_count - count;
      return 'Add ' + remaining + ' more to complete your ' + first.title + ' for ' + formatMoney(first.price);
    }

    // Exactly at first tier threshold
    if (count === first.item_count) {
      if (second) {
        var diff = (parseFloat(second.price) - parseFloat(first.price)).toFixed(2);
        return 'Your ' + first.title + ' is ready. Add ' + (second.item_count - first.item_count) + ' more scents to explore our ' + second.title + ' for ' + formatMoney(diff) + ' more.';
      }
      return 'Your ' + first.title + ' is complete.';
    }

    // Between first and second tier
    if (second && count < second.item_count) {
      var rem = second.item_count - count;
      return 'Add ' + rem + ' more to unlock your ' + second.title + ' for ' + formatMoney(second.price);
    }

    // Exactly at second tier threshold
    if (second && count === second.item_count) {
      if (third) {
        var diff2 = (parseFloat(third.price) - parseFloat(second.price)).toFixed(2);
        return 'Your ' + second.title + ' is ready. ' + (third.item_count - second.item_count) + ' more scents completes the full ' + third.title + ' for just ' + formatMoney(diff2) + ' more.';
      }
      return 'Your ' + second.title + ' is complete.';
    }

    // Between second and third tier
    if (third && count < third.item_count) {
      var rem2 = third.item_count - count;
      return 'Add ' + rem2 + ' more to complete your ' + third.title + ' for ' + formatMoney(third.price);
    }

    // At or beyond max tier
    if (third && count >= third.item_count) {
      return 'Your ' + third.title + ' is complete.';
    }

    return '';
  }

  // ------------------------------------------------------------------
  // Add to Cart button copy
  // ------------------------------------------------------------------
  function getButtonCopy(activeTier) {
    if (!activeTier) return 'Select Your Scents';
    return 'Add Your ' + activeTier.title + ' for ' + formatMoney(activeTier.price);
  }

  // ------------------------------------------------------------------
  // Progress bar node updates
  // ------------------------------------------------------------------
  function updateProgressBar(count) {
    var tiers = getTiers();
    var nodes = document.querySelectorAll('[data-tw-tier-node]');
    var lines = document.querySelectorAll('[data-tw-tier-line]');

    nodes.forEach(function (node) {
      var nodeCount = parseInt(node.getAttribute('data-tw-tier-node'), 10);
      if (count >= nodeCount) {
        node.classList.add('tw-tier-node--active');
      } else {
        node.classList.remove('tw-tier-node--active');
      }
    });

    // Fill connector lines between nodes
    lines.forEach(function (line) {
      var lineIndex = parseInt(line.getAttribute('data-tw-tier-line'), 10);
      // line index 0 = between node 0 and node 1, etc.
      if (tiers[lineIndex + 1] && count >= tiers[lineIndex + 1].item_count) {
        line.classList.add('tw-tier-line--active');
      } else {
        line.classList.remove('tw-tier-line--active');
      }
    });
  }

  // ------------------------------------------------------------------
  // Nudge text update
  // ------------------------------------------------------------------
  function updateNudge(count) {
    var nudgeEl = document.querySelector('[data-tw-nudge]');
    if (!nudgeEl) return;
    nudgeEl.textContent = getNudgeCopy(count);
  }

  function updateSecondaryNudge(count) {
      var el = document.querySelector('[data-tw-nudge-secondary]');
      if (!el) return;

      var tiers = getTiers();
      var exactTier = getExactTier(count);

      if (exactTier || count === 0) {
        el.textContent = '';
        return;
      }

      // Find the previous tier
      var prevTier = null;
      for (var i = tiers.length - 1; i >= 0; i--) {
        if (tiers[i].item_count < count) {
          prevTier = tiers[i];
          break;
        }
      }

      if (prevTier) {
        var toRemove = count - prevTier.item_count;
        el.textContent = 'Or remove ' + (toRemove === 1 ? 'a scent' : toRemove + ' scents') + ' to return to your ' + prevTier.title + '.';
      } else {
        el.textContent = '';
      }
    }

  // ------------------------------------------------------------------
  // Mobile sticky bottom bar
  // ------------------------------------------------------------------
  function updateMobileStickyBar(count) {
    var bar = document.querySelector('[data-tw-mobile-bar]');
    if (!bar) return;

    var tierEl = bar.querySelector('[data-tw-mobile-bar-tier]');
    var countEl = bar.querySelector('[data-tw-mobile-bar-count]');
    var btn = bar.querySelector('[data-tw-mobile-bar-btn]');

    // Show bar once any scent is selected
    if (count > 0) {
      bar.classList.add('is-visible');
      bar.removeAttribute('aria-hidden');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    var tiers = getTiers();
    var maxCount = tiers.length ? tiers[tiers.length - 1].item_count : 10;
    var exactTier = getExactTier(count);
    var activeTier = getActiveTier(count);

    // Tier label
    if (tierEl) {
      if (exactTier) {
        tierEl.textContent = exactTier.title + ' for $' + parseFloat(exactTier.price).toFixed(2).replace(/\.00$/, '');
      } else if (count > 0) {
        var nextTierForLabel = getNextTier(count);
        if (nextTierForLabel) {
          tierEl.textContent = 'Building your ' + nextTierForLabel.title;
        } else {
          tierEl.textContent = 'Building your journey';
        }
      } else {
        tierEl.textContent = '';
      }
    }

    // Count fraction
    if (countEl) {
      if (exactTier) {
        countEl.textContent = 'Select more scents or Add to Cart';
      } else {
        var nextTierForCount = getNextTier(count);
        if (nextTierForCount) {
          countEl.textContent = count + ' of ' + nextTierForCount.item_count + ' for ' + nextTierForCount.title;
        } else {
          countEl.textContent = count + ' scents selected';
        }
      }
    }

    // Button
    if (btn) {
      btn.textContent = 'Add to Cart';
      if (exactTier) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    }
  }

  // ------------------------------------------------------------------
  // Add to Cart button update
  // ------------------------------------------------------------------
  function updateAddToCartButton(count) {
    var btn = document.querySelector('[data-tw-atc-b]');
    if (!btn) return;

    var exactTier = getExactTier(count);

    if (exactTier) {
      btn.textContent = getButtonCopy(exactTier);
      btn.disabled = false;
      btn.classList.remove('tw-atc-b--disabled');
    } else {
      var activeTier = getActiveTier(count);
      btn.textContent = count === 0 ? 'Select Your Scents' : getNudgeCopy(count);
      btn.disabled = true;
      btn.classList.add('tw-atc-b--disabled');
      // Keep button copy clean on mobile sticky bar when between tiers
      btn.textContent = activeTier ? 'Keep Selecting Scents' : 'Select Your Scents';
    }
  }

  // ------------------------------------------------------------------
  // Selected scents list (sidebar / mobile summary)
  // ------------------------------------------------------------------
  function updateScentList() {
    var listEl = document.querySelector('[data-tw-scent-list-b]');
    if (!listEl) return;

    var scents = (window.TWBuilder && window.TWBuilder.selectedScents) ? window.TWBuilder.selectedScents : [];

    if (!scents.length) {
      listEl.innerHTML = '<li class="tw-scent-list-b__empty">No scents selected yet</li>';
      return;
    }

    // Group duplicates
    var counts = {};
    scents.forEach(function (s) {
      counts[s.title] = (counts[s.title] || 0) + 1;
    });

    var html = '';
    Object.keys(counts).forEach(function (title) {
      var qty = counts[title];
      html += '<li class="tw-scent-list-b__item">';
      html += '<span class="tw-scent-list-b__name">' + title + '</span>';
      if (qty > 1) {
        html += '<span class="tw-scent-list-b__qty">x' + qty + '</span>';
      }
      html += '</li>';
    });

    listEl.innerHTML = html;
  }

  // ------------------------------------------------------------------
  // Tier state update -- called whenever scent selection changes
  // Sets window.TWBuilder.selectedJourney and dispatches tw:journey:selected
  // when a tier threshold is hit, so tw-bundle-builder.js can build
  // the correct cart payload.
  // ------------------------------------------------------------------
  function onScentCountChanged(count) {
    updateProgressBar(count);
    updateNudge(count);
    updateAddToCartButton(count);
    updateScentList();
    updateSecondaryNudge(count);
    updateMobileStickyBar(count);

    var exactTier = getExactTier(count);

    if (exactTier) {
      // Populate the global state contract so tw-bundle-builder.js works unchanged
      window.TWBuilder.selectedJourney = {
        title: exactTier.title,
        item_count: exactTier.item_count,
        variant_id: exactTier.variant_id,
        price: String(exactTier.price)
      };
      window.TWBuilder.hasSelectedJourney = true;

      // Dispatch the locked event contract
      document.dispatchEvent(new CustomEvent('tw:journey:selected', {
        detail: {
          title: exactTier.title,
          item_count: exactTier.item_count,
          variant_id: exactTier.variant_id,
          price: exactTier.price
        },
        bubbles: true
      }));
    } else {
      // Between tiers -- clear journey selection so Add to Cart cannot fire
      // tw-scent-grid-b.liquid enforces no cart submission when journey is unset
      window.TWBuilder.hasSelectedJourney = false;
    }
  }

  // ------------------------------------------------------------------
  // Listen for scent selection changes from tw-scent-grid-b.liquid
  // tw-scent-grid-b dispatches tw:scents:changed with { count: N }
  // ------------------------------------------------------------------
  document.addEventListener('tw:scents:changed', function (e) {
    var count = (e.detail && typeof e.detail.count === 'number') ? e.detail.count : 0;
    onScentCountChanged(count);
  });

  // ------------------------------------------------------------------
  // Init on DOM ready
  // ------------------------------------------------------------------
  function init() {
    var count = (window.TWBuilder && window.TWBuilder.selectedScents)
      ? window.TWBuilder.selectedScents.length
      : 0;
    onScentCountChanged(count);

  // Wire mobile bar ATC button to same handler as sidebar button
    var mobileBarBtn = document.querySelector('[data-tw-mobile-bar-btn]');
    var sidebarAtcBtn = document.querySelector('[data-tw-atc-b]');
    if (mobileBarBtn && sidebarAtcBtn) {
      mobileBarBtn.addEventListener('click', function () {
        sidebarAtcBtn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();